<style lang="less">

body, p, ol, ul, li, h1, h2, h3, h4, h5, button{
	margin: 0;
	border: 0;
	padding: 0
}
a, button, li, input{
    outline: none;
	text-decoration: none;
}
.test_back{
	width: 32px;
	height: 32px;
	border-radius: 50%;
	position: fixed;
	bottom: 2px;
	right: 2px;
	background: #f2f2f2;
	border: 1px solid #eee;
	display: -webkit-box; display:flex;
	-webkit-box-align: center; align-items: center;
	-webkit-box-pack: center; justify-content: center;
}

.form{
	padding: 0 16px;
	overflow: hidden;
	.item{
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		height: 64px;
		border-bottom: 1px solid #f2f2f2;
		color: #000;
		font-size: 16px;
		padding: 0 8px;
		font-weight: 400;
		overflow: hidden;
		.label{
			-webkit-box-flex: 0 0 auto; -moz-box-flex: 0 0 auto; -ms-flex: 0 0 auto; flex: 0 0 auto;
			color: #000;
			font-size: 16px;
		}
		.cont{
			box-sizing: border-box;
			padding-left: 12px;
			-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
			input{
				width: 100%;
				font-size:14px;
				color:#000;
				overflow: hidden;
				text-align: right;
				background:#fff;
				font-weight: 600;
				height: 64px;
				border: 0;
				&::-webkit-input-placeholder{
					color: #ccc;
					font-size: 14px;
				}
				&.disable{
					color: #999;
				}
			}
		}
	}
	.explain{
		height: 43px;
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		padding: 0 8px;
		font-size: 12px;
		color: #999;
	}
	.tips{
		height: 43px;
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		padding: 0 8px;
		font-size: 12px;
		color: #d33a2a;
	}
}
.form_space{
	width: 100%;
	height: 12px;
	overflow: hidden;
	background: #f2f2f2;
}

.account_head{
	border-bottom: 12px solid #f2f2f2;
	.price{
		font-size: 50px;
		color: #dc2a2a;
		text-align: center;
		padding: 34px 0 4px 0;
		font-weight: 400;
	}
	.desc{
		color: #999;
		font-size: 14px;
		text-align: center;
	}
	.button{
		text-align: center;
		padding: 20px;
		button{
			width: 80%;
			border-radius: 23px;
			height: 46px;
			color: #fff;
			background: #dc2a2a;
			font-weight: 700;
		}
	}
	.info{
		display: -webkit-box; display:flex;
		padding: 30px 16px 30px 16px;
		.item{
			-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
			text-align: center;
			h3{
				height: 18px;
				font-size: 16px;
				line-height: 18px;
				font-weight: normal;
			}
			p{
				color: #999;
				font-size: 12px;
				padding-top: 9px;
			}
		}
	}
}

.empty_list{
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top: 0;
	display: flex;
	-webkit-box-align: center; align-items: center;
	-webkit-box-pack: center; justify-content: center;
	flex-direction: column;
	img{
		height: 120px;
	}
	h3{
		padding: 0 0 56px 12px;
		color: rgba(0,0,0,0.4);
		font-size: 20px;
	}
}

.NOFont{
	font-family:'roboto';
}

.space{
	background: #f2f2f2;
	height: 48px;
}
.cp{
	height: 40px;
	width: 100%;
	display: -webkit-box; display:flex;
	-webkit-box-align: center; align-items: center;
	-webkit-box-pack: center; justify-content: center;
	color: #b2b2b2;
	font-size: 10px;
	background: #f2f2f2;
}

.line_times{
	margin-top: 16px;
	padding: 30px 22px 30px;
	position: relative;
	.day{
		width: 100%;
		box-sizing: border-box;
		position: absolute;
		left: 0;
		top: 0;
		padding: 0 22px;
		display: -webkit-box; display:flex;
		-webkit-box-pack: space-between; justify-content: space-between;
		z-index: 999;
		.item{
			text-align: center;
			&:first-child {
				text-align: left;
			}
			&:last-child {
				text-align: right;
			}
			h4{
				font-weight: 400;
				height: 12px;
				padding-top: 10px;
				font-size: 10px;
				line-height: 10px;
				color: #666;
			}
			p{
				padding-top: 2px;
				font-size: 10px;
				color: #666;
			}
			&.active{
				.round{
					background: #c62520;
					&:after{
						background: #c62520;
					}
				}
			}
			.round{
				width: 6px;
				height: 6px;
				padding: 3px;
				display: inline-block;
				border-radius: 50%;
				background: #f7f8fb;
				&:after{
					content: ' ';
					width: 6px;
					height: 6px;
					display: block;
					border-radius: 50%;
					background: #f7f8fb;
				}
			}
		}
	}
	.line{
		height: 4px;
		background: #f7f8fb;
		width: 98%;
		margin: 0 auto;
		z-index: 0;
	}
}

.foot-btn-simple{
	height: 48px !important;
	.foot-btn-simple_btn_ext{
		height: 48px !important;
	}
	.foot-btn-simple_btn{
		height: 48px !important;
	}
}

.char{
	.title{
		padding: 12px 16px 16px 16px;
		display: -webkit-box; display:flex;
		h3{
			-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
			font-size: 14px;
		}
		p{
			font-size: 12px;
			color: #2e4276;
			font-weight: 400;
		}
	}
	.cont{
		height: 180px;
		padding:0 17px 17px 17px;
	}
}

body{
	.agreement{
		bottom: 58px;
	}
}

</style>

<template>
	<div id="app">
		<router-view/>
		<!-- <div class="test_back" onclick="history.back()"> 《 </div> -->
	</div>
</template>

<script>
export default {
	name: 'app'
}
</script>



// WEBPACK FOOTER //
// src/App.vue